<div class="auth-container">
  <div class="row auth-main">
    <div class="col-xl-5 d-none d-xl-block px-0 left-col">
      <div class="image-wrapper"></div>
    </div>

    <div class="col-sm-7 auth-form-section">
      <div class="form-section">
        <div class="auth-wrapper">
          <h5 class="welcome-msg">REESTABLECER CONTRASENA</h5>
          <p class="auth-signup-text text-muted">
            CREA UNA NUEVA CONTRASENA PARA ACCEDER A LA PLATAFORMA. ASEGURATE DE RECORDARLA.
          </p>

          <form [formGroup]="authForm" class="validate-form">
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                  <mat-label>NUEVA CONTRASENA</mat-label>
                  <input
                    [type]="hide ? 'password' : 'text'"
                    autocomplete="nope"
                    formControlName="password"
                    matInput
                  />
                  <mat-icon
                    (click)="hide = !hide"
                    class="material-icons-outlined pwd-toggle p-3"
                    matSuffix
                  >
                    {{ hide ? 'visibility_off' : 'visibility' }}
                  </mat-icon>
                </mat-form-field>

                <div *ngIf="password?.touched && password?.hasError('required')" class="custom-error-below">
                  <small class="text-danger">LA CONTRASENA ES REQUERIDA</small>
                </div>

                <div *ngIf="password?.touched && password?.hasError('pattern')" class="custom-error-below">
                  <small class="text-danger">
                    LA CONTRASENA DEBE TENER AL MENOS 12 CARACTERES, 1 SIMBOLO, 1 NUMERO, 1 MAYUSCULA Y 1 MINUSCULA.
                  </small>
                </div>
              </div>

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                  <mat-label>CONFIRMA TU CONTRASENA</mat-label>
                  <input
                    [type]="chide ? 'password' : 'text'"
                    autocomplete="nope"
                    formControlName="confirmedPassword"
                    matInput
                  />
                  <mat-icon
                    (click)="chide = !chide"
                    class="material-icons-outlined pwd-toggle p-3"
                    matSuffix
                  >
                    {{ chide ? 'visibility_off' : 'visibility' }}
                  </mat-icon>
                </mat-form-field>

                <div *ngIf="confirmedPassword?.touched && confirmedPassword?.hasError('required')" class="custom-error-below">
                  <small class="text-danger">LA CONFIRMACION DE LA CONTRASENA ES REQUERIDA</small>
                </div>

                <div *ngIf="confirmedPassword?.touched && confirmedPassword?.hasError('pattern')" class="custom-error-below">
                  <small class="text-danger">
                    LA CONTRASENA DEBE TENER AL MENOS 12 CARACTERES, 1 SIMBOLO, 1 NUMERO, 1 MAYUSCULA Y 1 MINUSCULA.
                  </small>
                </div>

                <div *ngIf="passwordsDoNotMatch" class="custom-error-below">
                  <small class="text-danger">LAS CONTRASENAS NO COINCIDEN</small>
                </div>
              </div>
            </div>

            <div class="container-auth-form-btn mt-5">
              <button
                (click)="resetPassword()"
                [disabled]="authForm.invalid || passwordsDoNotMatch"
                class="auth-form-btn"
                color="accent"
                mat-flat-button
                type="button"
              >
                REESTABLECER CONTRASENA
              </button>
            </div>

            <div class="w-full p-t-25 text-center">
              <div>
                <a class="txt1" routerLink="/authentication/signin">
                  ACCEDER A LA PLATAFORMA
                </a>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>
</div>
